<pershing-responsive [small]="smallRef" [medium]="mediumRef" [large]="largeRef" [respondToWindow]="true">
</pershing-responsive>
<nxi-biometric-auth *ngIf="isUserInNativeApp"></nxi-biometric-auth>
<ng-template #smallRef>
  <ng-template [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletContext]="{device : 'small-container'}">
  </ng-template>
</ng-template>
<ng-template #mediumRef>
  <ng-template [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletContext]="{device : 'medium-container'}">
  </ng-template>
</ng-template>
<ng-template #largeRef>
  <ng-template [ngTemplateOutlet]="footerTemplate" [ngTemplateOutletContext]="{device : 'large-container'}">
  </ng-template>
</ng-template>

<ng-template #footerTemplate let-device="device">
  <footer class="fw-Footer {{device}}" role="contentinfo">
    <div layout="row" class="fw-Footer_Container">
      <!--Site specific primary content-->
      <div *ngIf="siteSpecificPrimHasContent" class="fw-Footer_PrimaryContent margin-bottom-20 {{device}}">
        <content-management (hasContent)="checkContent($event)" [isFooter]=true communityName={{community}}
          articleId="site_specific_footer_primary">
        </content-management>
      </div>
      <div class="fw-FooterSecondary {{device}}">
        <!-- Secondary footer container-->
        <content-management [isFooter]=true communityName="{{community}}" articleId="footer_secondary">
        </content-management>
      </div>
      <!-- Site specific footer container-->
      <div class="fw-Footer_SecondaryContent {{device}}">
        <content-management [isFooter]=true communityName={{community}} articleId="site_specific_footer_secondary">
        </content-management>
      </div>
    </div>
    <div layout="row" class="fw-FooterPrimary {{device}}">
      <!-- Primary footer container-->
      <content-management [isFooter]=true communityName={{community}} [doNotOverrideCommunityName]="overrideFdicDisclosure" articleId="footer_primary"></content-management>
    </div>
  </footer>
</ng-template>